<ng-container *transloco="let t">
  <ng-container>
    <!-- STATS -->
    @if ((featuredReviewsStats$ | async) && (featuredReviewsStats$ | async)?.totalCount) {
      <section class="product-reviews-stats">
        <div class="main-stats">
          <span class="flex flex-row align-base">
            @for (
              n of range((featuredReviewsStats$ | async)?.averageRating);
              track trackByIndex($index)
            ) {
              <popsy-icon-star-filled
                class="icon fill-gray-dark"></popsy-icon-star-filled>
            }
            @if (isAverageRatingPointFive) {
              <popsy-icon-star-half-filled
                class="icon fill-gray-dark"></popsy-icon-star-half-filled>
            }
            <span class="fixed-space-8" aria-hidden="true"></span>
            <span class="small">{{ (featuredReviewsStats$ | async)?.totalCount }} </span>
            <span class="fixed-space-4" aria-hidden="true"></span>
            <span class="small"> {{ t('label_user_reviews') }} </span>
          </span>
        </div>
      </section>
    }
    @if (
      !(featuredReviewsStats$ | async) || !(featuredReviewsStats$ | async)?.totalCount
    ) {
      <section class="product-reviews-stats mockup">
        <span class="flex flex-row align-base">
          <popsy-icon-star-filled class="icon fill-gray-dark"></popsy-icon-star-filled>
          <popsy-icon-star-filled class="icon fill-gray-dark"></popsy-icon-star-filled>
          <popsy-icon-star-filled class="icon fill-gray-dark"></popsy-icon-star-filled>
          <popsy-icon-star-filled class="icon fill-gray-dark"></popsy-icon-star-filled>
          <popsy-icon-star-filled class="icon fill-gray-dark"></popsy-icon-star-filled>
        </span>
      </section>
    }
  </ng-container>
</ng-container>
